const divFormService = {
  inspectedBy: 'Revisado por:',
  itemLabel: 'Lugar',
  equipment: 'Equipo',
  serialNumber: 'S/N:',
  reference: 'Punto de referencia:',
  description: 'Descripción del equipo:',
  fileStillUploading: 'Espere a que se carguen todos los archivos',
  fileError: 'Existen archivos enviados con error',
  equipmentModelDescription: 'Descripción del Tipo de equipo: '
};

export default divFormService;
